module.exports = __webpack_public_path__ + "img/1.2c35a7bc.png";